export const GlobalStyles = () => (
    <style>{`
        /* --- Base & Reset --- */
        :root {
            --slate-50: #f8fafc; --slate-100: #f1f5f9; --slate-200: #e2e8f0; --slate-300: #cbd5e1;
            --slate-400: #94a3b8; --slate-500: #64748b; --slate-600: #475569; --slate-700: #334155;
            --slate-800: #1e293b; --slate-900: #0f172a;
            --blue-500: #2E9DB1; --blue-600: #2E9DB1; --blue-700: #2E9DB1;
            --blue-100: #dbeafe; --blue-800: #1e40af;
            --green-100: #dcfce7; --green-600: #16a34a; --green-700: #15803d; --green-800: #166534;
            --red-100: #fee2e2; --red-800: #991b1b;
            --yellow-100: #fef9c3; --yellow-600: #ca8a04; --yellow-800: #854d0e;
            --orange-100: #ffedd5; --orange-800: #9a3412;
            --white: #ffffff; --black: #000000;
            --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
        }
        *, *::before, *::after { box-sizing: border-box; }
        body { margin: 0; font-family: 'Be Vietnam Pro', sans-serif; background-color: var(--slate-50); color: var(--slate-600); }

        /* --- General Content (Shared) --- */
        .page.active { animation: fadeIn 0.3s ease-in-out; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .page-title { font-size: 1.875rem; font-weight: 700; color: var(--slate-800); margin: 0 0 1.5rem 0; }
        .content-card { background-color: var(--white); border-radius: 0.5rem; box-shadow: var(--shadow); overflow: hidden; }

        /* --- Tables (Shared) --- */
        .table-wrapper { overflow-x: auto; }
        .data-table { width: 100%; font-size: 0.875rem; text-align: left; color: var(--slate-500); }
        .data-table thead { font-size: 0.75rem; color: var(--slate-700); text-transform: uppercase; background-color: var(--slate-50); }
        .data-table th, .data-table td { padding: 0.75rem 1.5rem; white-space: nowrap; }
        .data-table tbody tr { border-bottom: 1px solid var(--slate-200); }
        .data-table td[data-label="User Email"] { font-weight: 500; color: var(--slate-900); }
        .no-data { text-align: center; padding: 1rem; color: var(--slate-500); }
        .confirmed { color: var(--green-600); font-weight: 600; }
        .action-button { font-weight: 500; color: var(--blue-600); text-decoration: none; border:none; background:none; cursor:pointer;}
        .action-button:hover { text-decoration: underline; }

        /* --- Status Badges (Shared) --- */
        .status-badge { font-size: 0.75rem; font-weight: 500; padding: 0.125rem 0.625rem; border-radius: 9999px; white-space: nowrap; }
        .status-completed { background-color: var(--green-100); color: var(--green-800); }
        .status-failed { background-color: var(--red-100); color: var(--red-800); }
        .status-pending { background-color: var(--yellow-100); color: var(--yellow-800); }
        .status-awaiting { background-color: var(--blue-100); color: var(--blue-800); }
        .status-pending-pwc { background-color: var(--yellow-100); color: var(--yellow-800); }
        .status-pending-meteora { background-color: var(--orange-100); color: var(--orange-800); }
        .status-pending-pwc-final { background-color: var(--yellow-100); color: var(--yellow-800); }

        /* --- Buttons (Shared) --- */
        .button {
            padding: 0.5rem 1rem; font-weight: 600; border-radius: 0.375rem; border: none; cursor: pointer; transition: background-color 0.2s;
        }
        .button.primary { background-color: var(--blue-600); color: var(--white); }
        .button.primary:hover { background-color: var(--blue-700); }
        .button.secondary { background-color: var(--slate-600); color: var(--white); }
        .button.secondary:hover { background-color: var(--slate-700); }
        .button.default { background-color: var(--slate-200); color: var(--slate-700); }
        .button.default:hover { background-color: var(--slate-300); }
        .button.full-width { width: 100%; }
    `}</style>
);
